export default {
  allAdvances: (state) => state.advances,
  allAdvancesForAccount: (state) => state.advancesForAccount,
  advancesLoading: (state) => state.advancesLoading,
  allAdvanceModifications: (state) => state.advanceModifications,
  advanceModification: (state) => state.advanceModification,
  advanceModificationsDialog: (state) => state.advanceModificationsDialog
}
